angular.module('picmonicpublic', [
    'picmonic-common'
]);
